module.exports = __webpack_public_path__ + "img/tax01.48f15f0a.png";